import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  constructor(private dialogSv: DialogService) {
  }

  async loadPromise(promise: Promise<any>, message?: string, title?: string, showSpinner = true) {
    let msg = message || "Loading...";

    if (showSpinner) {
      msg = "<i class='fas fa-spin fa-spinner mr-2'></i> " + msg;
    }

    const id = this.dialogSv.show({
      message: msg,
      title,
      html: true,
      allowClose: false,
      cb: () => { }
    });

    try {
      const result = await promise;
      return result;
    }
    finally {
      this.dialogSv.closeModal(id);
    }
  }
}
